import { IRoutePattern } from "../@types/Route";
import { Alert } from "../assets/icons/Alert";
import { Book } from "../assets/icons/Book";
import { Calendar } from "../assets/icons/Calendar";
import { DollarBill } from "../assets/icons/DollarBill";
import { DoubleFlag } from "../assets/icons/DoubleFlag";
import { File } from "../assets/icons/File";
import { Forms } from "../assets/icons/Forms";
import { Lab } from "../assets/icons/Lab";
import { Message } from "../assets/icons/Message";
import { Note } from "../assets/icons/Note";
import { People } from "../assets/icons/People";
import { PhoneDevice } from "../assets/icons/PhoneDevice";
import { Pill } from "../assets/icons/Pill";
import { PinnedGraph } from "../assets/icons/PinnedGraph";
import { Prom } from "../assets/icons/Prom";
import { ProtocolActions } from "../assets/icons/ProtocolActions";
// import { Spirometry } from "../assets/icons/Spirometry";
import { Vitals } from "../assets/icons/Vitals";

export const patientListChildRoutes: IRoutePattern[] = [
  {
    name: "Active",
    labelKey: "nav_patientList_active",
    path: "/patients/active",
    disabled: false,
    Icon: People,
    context: "Patient List",
  },
  {
    name: "Alerts & tasks",
    labelKey: "nav_patientList_alerts",
    path: "/patients/alerts",
    disabled: false,
    Icon: Alert,
    context: "Patient List",
  },
  {
    name: "Flagged",
    labelKey: "nav_patientList_flagged",
    path: "/patients/flagged",
    disabled: false,
    Icon: DoubleFlag,
    context: "Patient List",
  },
  {
    name: "Archived",
    labelKey: "nav_patientList_archived",
    path: "/patients/archived",
    disabled: false,
    Icon: File,
    context: "Patient List",
  },
  {
    name: "Billing",
    labelKey: "nav_patientList_billing",
    path: "/patients/billing",
    disabled: false,
    Icon: DollarBill,
    context: "Patient List",
    hidden: true,
  },
];

export const patientPageChildRoutes: IRoutePattern[] = [
  {
    name: "Pinned",
    labelKey: "patientPage_nav_pinned",
    path: "/patients/:patientId/pinned",
    disabled: false,
    Icon: PinnedGraph,
    context: "Patient Page",
  },
  {
    name: "Measurements",
    labelKey: "patientPage_nav_measurements",
    path: "/patients/:patientId/measurements",
    disabled: false,
    Icon: Vitals,
    context: "Patient Page",
  },
  {
    name: "Labs",
    labelKey: "patientPage_nav_labs",
    path: "/patients/:patientId/labs",
    disabled: false,
    Icon: Lab,
    context: "Patient Page",
  },
  {
    name: "Alerts",
    labelKey: "patientPage_nav_alerts",
    path: "/patients/:patientId/alerts",
    disabled: false,
    Icon: Alert,
    context: "Patient Page",
  },
  {
    name: "Appointments",
    labelKey: "patientPage_nav_appointments",
    path: "/patients/:patientId/appointments",
    disabled: false,
    Icon: Calendar,
    context: "Patient Page",
  },
  {
    name: "PROM",
    labelKey: "patientPage_nav_prom",
    path: "/patients/:patientId/proms",
    disabled: false,
    Icon: Prom,
    context: "Patient Page",
  },
  {
    name: "Protocol actions",
    labelKey: "patientPage_nav_protocolActions",
    path: "/patients/:patientId/protocol-actions",
    disabled: false,
    Icon: ProtocolActions,
    context: "Patient Page",
  },
  {
    name: "Forms",
    labelKey: "patientPage_nav_forms",
    path: "/patients/:patientId/forms",
    disabled: false,
    Icon: Forms,
    context: "Patient Page",
  },
  {
    name: "Medication",
    labelKey: "patientPage_nav_medication",
    path: "/patients/:patientId/medication",
    disabled: false,
    Icon: Pill,
    context: "Patient Page",
  },
  {
    name: "Journal",
    labelKey: "patientPage_nav_journal",
    path: "/patients/:patientId/journal",
    disabled: false,
    Icon: Book,
    context: "Patient Page",
  },
  {
    name: "Notes",
    labelKey: "patientPage_nav_notes",
    path: "/patients/:patientId/notes",
    disabled: false,
    Icon: Note,
    context: "Patient Page",
  },
  {
    name: "Messages",
    labelKey: "patientPage_nav_messages",
    path: "/patients/:patientId/messages",
    disabled: false,
    Icon: Message,
    context: "Patient Page",
  },
  {
    name: "Devices",
    labelKey: "patientPage_nav_devices",
    path: "/patients/:patientId/devices",
    disabled: false,
    Icon: PhoneDevice,
    context: "Patient Page",
  },
];
